module.exports = __webpack_public_path__ + "img/p29.28175948.png";